import constants from './constants/common';
import control from './controls/control';
import initHtmlEmbedElements from './helpers/init-html-embed-elements';

const getExtension = () => ({
  injections: {
    afterViewLoad: initHtmlEmbedElements,
    afterElementInsert: initHtmlEmbedElements,
  },
  slug: constants.slug,
  title: 'HTML widget extension',
  description: 'Extension for adding custom HTML',
  settings: {
    querySelector: 'ws-html-embed',
  },
  ui: {
    control: [control],
  },
});

export default getExtension;
